module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getProducts.length > 0) ? _c('div', {
    ref: "products",
    staticClass: "products"
  }, _vm._l((_vm.getProducts), function(product) {
    return _c('card-product-big', {
      key: product.id,
      attrs: {
        "product": product
      }
    })
  })) : _c('div', {
    staticClass: "d-flex align-center flex-column sorry-container"
  }, [_c('h1', {
    staticClass: "not-found"
  }, [_vm._v("Sin resultados")]), _vm._v(" "), _c('h3', {
    staticClass: "sorry"
  }, [_vm._v("Lo sentimos, no hay productos que coincidan con tu búsqueda")]), _vm._v(" "), _c('button', {
    staticClass: "go-init",
    style: (("background-color:" + (_vm.globalColors.primary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goTo
    }
  }, [_vm._v("Regresar a inicio")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b76bc0ea","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/Products.vue
// module id = 1157
// module chunks = 4